import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_AUTHENTIC;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
